// ======================================================================
// File Name       : UserHistoryStudentTopContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import * as groupActions from '../../../actions/GroupAction';
import * as userActions from '../../../actions/UserAction';
import * as UserHistoryStudentAction from '../../../actions/UserHistoryStudentAction';
import DialogConfirm from '../../../components/DialogConfirm';
import Header from '../../../components/Header';
import MessageSearch from '../../../components/MessageSearch';
import PaginationCustom from '../../../components/Pagination';
import ModalConductor from '../../../components/modal/ModalConductor';
import UserHistoryStudentList from '../../../components/userHistory/student/UserHistoryStudentList';
import UserHistoryStudentSearch from '../../../components/userHistory/student/UserHistoryStudentSearch';
import * as MessageTemplate from '../../../constants/MessageTemplate';
import * as Path from '../../../constants/PathConstants';
import * as actionType from '../../../constants/actionTypes/page';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../../constants/index';
import { showExportCSVSuccessMessage } from '../../../utils/index';

class UserHistoryStudentTopContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {
        userName: '',
        groupSecernId: '',
        dormantState: true,
        userSortType: null,
        ascendingDescendingSort: null,
        startPosition: null,
        returnMaxNum: RETURN_MAX_NUM,
      },
      showConfirmModal: false,
      hideModal: false,
      returnMaxNum: RETURN_MAX_NUM,
      isAllowShowSearchMessage: false,
    };
    this.searchData = this.searchData.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.onFileExportCancel = this.onFileExportCancel.bind(this);
    this.onFileExportOk = this.onFileExportOk.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleShowGroupDlg = this.handleShowGroupDlg.bind(this);
    this.removeSelectedGroup = this.removeSelectedGroup.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.initData = this.initData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    const { searchCondition } = this.props;
    this.setState({
      ...this.state,
      filterData: searchCondition,
    }, () => {
      if (searchCondition && searchCondition.selectedTargetGroup) {
        if (Object.keys(searchCondition.selectedTargetGroup).length > 0) {
          this.props.dispatch(groupActions.selectedGroupOnDialog(searchCondition.selectedTargetGroup));
        }
      }
    });
    this.props.dispatch(userActions.getGroupListAll());
    this.initData();
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.userSortType) {
        column = initialValues.userSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues, column, startPosition);
    this.props.dispatch(
      UserHistoryStudentAction.getUserListBySearch(
        param.searchInfo.userName,
        param.searchInfo.groupSecernId,
        param.searchInfo.dormantState,
        param.searchInfo.userSortType,
        param.searchInfo.ascendingDescendingSort,
        param.searchInfo.startPosition,
        RETURN_MAX_NUM,
        SELECT_TARGET_DATA.DATA,
      ),
    ).then(() => {
      this.props.dispatch(UserHistoryStudentAction.fetchGroupStructure());
      this.setState({ isAllowShowSearchMessage: false });
    });
  }

  createParams(data, column, startPosition) {
    const filterData = { ...data };
    const { authedUser: { dormantUserDataAcquisitionPermissionFlag } } = this.props;
    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }

    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.userSortType = column.sortBy;
    }
    if (data && data.userName) {
      filterData.userName = data.userName;
    } else {
      filterData.userName = '';
    }

    if (dormantUserDataAcquisitionPermissionFlag) {
      if (data && data.dormantState) {
        filterData.dormantState = data.dormantState;
      } else {
        filterData.dormantState = false;
      }
    } else {
      filterData.dormantState = false;
    }

    if (!column) {
      filterData.ascendingDescendingSort = 0;
      filterData.userSortType = null;
    }
    filterData.returnMaxNum = RETURN_MAX_NUM;
    if (data.selectedTargetGroup && data.selectedTargetGroup.groupSecernId) {
      filterData.groupSecernId = data.selectedTargetGroup.groupSecernId;
    }
    const param = {
      searchInfo: filterData,
    };
    return param;
  }

  componentWillUnmount() {

    // STEP14.1.0 TAS-22243 START
    const { formValues, selectedTargetGroup, searchCondition } = this.props;
    if (searchCondition.selectedTargetGroup) {
      formValues.selectedTargetGroup = searchCondition.selectedTargetGroup;
    } else {
      formValues.selectedTargetGroup = selectedTargetGroup;
    }
    // STEP14.1.0 TAS-22243 END
    this.props.dispatch(groupActions.selectedGroupOnDialog(null));
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.USER_HISTORY_STUDENT_LIST,
      searchCondition : formValues,
    });
  }

  goToDetail(userSecernId) {
    const { invalid, formValues, selectedTargetGroup } = this.props;
    const searchCondition = formValues;
    if (selectedTargetGroup) {
      formValues.selectedTargetGroup = selectedTargetGroup;
    }
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: Path.USER_HISTORY_STUDENT_LIST,
        searchCondition,
      });
    }
    const path = Path.USER_HISTORY_STUDENT_DETAIL.replace(':id', userSecernId);
    this.props.history.push(path);
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid, selectedTargetGroup } = this.props;
    if (invalid) {
      return;
    }
    let groupSecernId = '';
    if (selectedTargetGroup && selectedTargetGroup.groupSecernId) {
      groupSecernId = selectedTargetGroup.groupSecernId;
    }
    const filterData = {
      startPosition: formValues.startPosition,
      userSortType: formValues.userSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      userName: formValues.userName,
      groupSecernId,
      dormantState: formValues.dormantState,
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('userSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(
        UserHistoryStudentAction.getUserListBySearch(
          paramSearch.searchInfo.userName,
          paramSearch.searchInfo.groupSecernId,
          paramSearch.searchInfo.dormantState,
          paramSearch.searchInfo.userSortType,
          paramSearch.searchInfo.ascendingDescendingSort,
          paramSearch.searchInfo.startPosition,
          paramSearch.searchInfo.returnMaxNum,
          SELECT_TARGET_DATA.DATA,
        ),
      ).then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.userSortType) {
      column = formValues.userSortType;
    }
    this.searchData(startPosition, column);
  }

  searchData(startPosition, column) {
    const { filterData } = this.state;
    const { invalid, dispatch, formValues } = this.props;
    if (invalid) {
      return;
    }
    const searchInfo = { ...filterData };
    if (isNaN(filterData.dormantState)) {
      searchInfo.dormantState = true;
    }
    const paramSearch = this.createParams(searchInfo, column, startPosition);
    this.props.dispatch(
      UserHistoryStudentAction.getUserListBySearch(
        paramSearch.searchInfo.userName,
        paramSearch.searchInfo.groupSecernId,
        paramSearch.searchInfo.dormantState,
        paramSearch.searchInfo.userSortType,
        paramSearch.searchInfo.ascendingDescendingSort,
        paramSearch.searchInfo.startPosition,
        paramSearch.searchInfo.returnMaxNum,
        SELECT_TARGET_DATA.DATA,
      ),
    ).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  handleShowGroupDlg() {
    const { dispatch } = this.props;
    dispatch(UserHistoryStudentAction.openGroupSelectDialog());
  }

  openFileExportConfirm(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showConfirmModal: true });
  }

  onFileExportCancel() {
    this.setState({ showConfirmModal: false });
  }

  /**
  * Remove selected group
  */
  removeSelectedGroup() {
    const { selectedTargetGroup } = this.props;
    const groupSecernId = null;
    this.props.dispatch(groupActions.selectedGroupOnDialog(groupSecernId));
    this.props.dispatch({
      type: actionType.CLEAR_SEARCH_CONDITION,
    });
  }

  onFileExportOk() {
    this.setState({ showConfirmModal: false });
    const { userHistoryData, formValues, selectedTargetGroup } = this.props;
    let groupSecernId = '';
    if (selectedTargetGroup && selectedTargetGroup.groupSecernId) {
      groupSecernId = selectedTargetGroup.groupSecernId;
    }
    const searchInfo = {
      groupSecernId,
      userName: formValues ? formValues.userName : '',
    };
    this.props.dispatch(
      UserHistoryStudentAction.exportUserList(searchInfo, SELECT_TARGET_DATA.CSV)).then(() => {
        showExportCSVSuccessMessage();
      });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }
  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }


  render() {
    const { dormantState, startPosition } = this.state;
    const {
      selectedTargetGroup,
      groupList,
      groupRelationList,
      recordNum,
      courseStatusList,
      userList,
      searchCondition,
      user,
      eachUserCourseStatusCount,
      authedUser: { dormantUserDataAcquisitionPermissionFlag },
    } = this.props;
    let groupSecernId = null;
    if (selectedTargetGroup) {
      groupSecernId = selectedTargetGroup.groupSecernId;
    }
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={userList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <UserHistoryStudentSearch
          groupList={groupList}
          groupSecernId={groupSecernId}
          dormantState={dormantState}
          onSearchBtnClick={this.clickSearchButton}
          onShowTreeGroupListClick={this.handleShowGroupDlg}
          removeSelectedGroup={this.removeSelectedGroup}
          selectedTargetGroup={selectedTargetGroup}
          openExportDialog={this.openFileExportConfirm.bind(this, MessageTemplate.BULK_EXPORT, null)}
          dormantUserDataAcquisitionPermissionFlag={dormantUserDataAcquisitionPermissionFlag}
        />
        <UserHistoryStudentList
          {...this.props}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          recordNum={recordNum}
          getStartEndData={this.getStartEndData}
          hoverIndex={hoverIndex}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
        <DialogConfirm
          showModal={this.state.showConfirmModal}
          onCancel={this.onFileExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onFileExportOk}
        />
        <ModalConductor />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userHistoryStudent, user } = state;
  const { userHistoryData, eachUserCourseStatusCount } = userHistoryStudent;
  const { parentPath, searchCondition } = state.page;
  const { groupList, groupRelationList, userList, courseStatusListForList, recordNum } = userHistoryData;
  const { userHistoryStudentTop } = state.form;
  const { selectedTargetGroup } = state.group;
  const { authedUser } = state.authed;
  let initial = {
    userName: '',
    groupSecernId: '',
    dormantState: true,
    userSortType: null,
    ascendingDescendingSort: null,
    startPosition: 0,
    returnMaxNum: RETURN_MAX_NUM,
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };
  if (parentPath === Path.USER_HISTORY_STUDENT_LIST) {
    if (searchCondition) {
      initial = {
        userName: searchCondition.userName,
        selectedTargetGroup: searchCondition.selectedTargetGroup,
        groupSecernId: searchCondition.groupSecernId,
        dormantState: searchCondition.dormantState,
        userSortType: searchCondition.userSortType,
        ascendingDescendingSort: searchCondition.ascendingDescendingSort,
        startPosition: searchCondition.startPosition,
        returnMaxNum: RETURN_MAX_NUM,
        selectTargetData: SELECT_TARGET_DATA.DATA,
      };
    }
  }
  return {
    ...{
      userHistoryData,
      userHistoryStudent,
      userHistoryStudentTop,
      groupList,
      groupRelationList,
      recordNum,
      userList,
      selectedTargetGroup,
      courseStatusList: courseStatusListForList,
      eachUserCourseStatusCount,
    },
    parentPath,
    searchCondition,
    initialValues: initial,
    formValues: getFormValues('userHistoryStudentTop')(state),
    authedUser,
    user,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'userHistoryStudentTop', // a unique identifier for this form
    touchOnChange: true,
    enableReinitialize: true,
  })(UserHistoryStudentTopContainer),
);
